var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import styled from 'styled-components';
import { X_AXIS, Y_AXIS } from "../../Popover";
import { BASE_FONT, clearProps, createUIElement, SPACING_M, SPACING_S } from "../../helpers";
import { NotificationIcon } from './NotificationIcon';
import { Icon, ICON_SIZES } from "../../Icon";
import { useDropdown } from "../../controls/Dropdown";
import { STACK_ALIGN, STACK_DIRECTION, STACK_DISTRIBUTION, STACK_GAP, StackView } from "../../StackView";
import { NotificationMessage } from './NotificationMessage';
import { INDENT, View, VIEW_ALIGN, VIEW_BG_VIEW, VIEW_BORDER, VIEW_DISTRIBUTION } from "../../View";
import { Text } from "../../Text";
import { Toggle } from "../../Toggle";
import { Button, BUTTON_VIEW } from "../../Button";
import { ClearAllIcon } from "../../icons";
var MAX_WIDTH_POPOVER = '720px';
var MAX_HEIGHT_POPOVER = '640px';
// TODO: Extract Wrapper as common component for Profile and etc
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-shrink: 0; /* if parent is flexbox-container */\n    box-sizing: border-box;\n    display: inline-flex;\n    padding: ", " ", ";\n\n    font: ", ";\n    color: ", ";\n    background-color: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\n    cursor: pointer;\n\n    &:hover {\n        background-color: ", ";\n    }\n"], ["\n    flex-shrink: 0; /* if parent is flexbox-container */\n    box-sizing: border-box;\n    display: inline-flex;\n    padding: ", " ", ";\n\n    font: ", ";\n    color: ", ";\n    background-color: ", ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\n    cursor: pointer;\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), SPACING_S, SPACING_M, BASE_FONT, function (_a) {
    var theme = _a.theme;
    return theme.colorLinkHeader;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorBackgroundHeader;
}, function (_a) {
    var theme = _a.theme;
    return theme.colorHeaderTabHover;
});
var NotificationList = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n"], ["\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n"])));
var NotificationFooter = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: ", ";\n"], ["\n    background: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    var _b, _c;
    return (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.backgrounds) === null || _c === void 0 ? void 0 : _c.normal;
});
var PopoverContent = styled(StackView)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    max-width: ", ";\n    max-height: ", ";\n"], ["\n    max-width: ", ";\n    max-height: ", ";\n"])), MAX_WIDTH_POPOVER, MAX_HEIGHT_POPOVER);
var Empty = function (_a) {
    var text = _a.text, rest = __rest(_a, ["text"]);
    return (React.createElement(View, { "data-selector-id": rest['data-selector-id'], spaceAll: INDENT.l, align: VIEW_ALIGN.center, distribution: VIEW_DISTRIBUTION.center, backgroundView: VIEW_BG_VIEW.neutral },
        React.createElement(Text, null, text)));
};
export var AppBarNotification = createUIElement('AppBarNotification', function (_a, ref) {
    var className = _a.className, _b = _a.noAutoDisplay, noAutoDisplay = _b === void 0 ? false : _b, _c = _a.shownState, shownState = _c === void 0 ? false : _c, _d = _a.messages, messages = _d === void 0 ? [] : _d, _e = _a.unread, unread = _e === void 0 ? false : _e, _f = _a.empty, empty = _f === void 0 ? false : _f, _g = _a.isAutoDisplay, isAutoDisplay = _g === void 0 ? false : _g, onAutoDisplayChange = _a.onAutoDisplayChange, onClearAllClick = _a.onClearAllClick, onDidHide = _a.onDidHide, onDidShow = _a.onDidShow, texts = _a.texts, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "noAutoDisplay", "shownState", "messages", "unread", "empty", "isAutoDisplay", "onAutoDisplayChange", "onClearAllClick", "onDidHide", "onDidShow", "texts", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var messagesList = messages
        .map(function (_a, index) {
        var _b;
        var title = _a.title, textIcon = _a.textIcon, titleIcon = _a.titleIcon, text = _a.text, onCloseClick = _a.onCloseClick, id = _a.id, read = _a.read, render = _a.render;
        if (typeof render === 'function') {
            var customElement = render({
                title: title,
                textIcon: textIcon,
                titleIcon: titleIcon,
                text: text,
                onCloseClick: onCloseClick,
                id: id
            });
            if (!customElement) {
                return null;
            }
            return React.cloneElement(customElement, (_b = {
                    key: "" + (id || "idx_" + index)
                },
                _b['data-selector-id'] = "notification-msg-" + (id || "idx_" + index),
                _b));
        }
        return (React.createElement(NotificationMessage, { testId: "notification-msg-" + (id || "idx_" + index), key: "" + (id || "idx_" + index), read: read, title: title, titleIcon: titleIcon, textIcon: textIcon, text: text, hasBorder: !!index, onCloseClick: onCloseClick }));
    })
        .filter(Boolean);
    var isEmpty = empty || !messagesList.length;
    var rootRef = useRef(null);
    var buttonRef = ref || rootRef;
    var showClearAll = !!onClearAllClick;
    var element = useDropdown({
        ref: buttonRef,
        initialActiveState: !noAutoDisplay && shownState,
        onDidHide: onDidHide,
        onDidShow: onDidShow,
        popoverConfig: [
            { xAxis: X_AXIS.insideRight, yAxis: Y_AXIS.outsideBottom },
            { xAxis: X_AXIS.insideLeft, yAxis: Y_AXIS.outsideBottom }
        ],
        renderControl: function (_a) {
            var button = _a.button;
            var dataSelectorId = 'appbar-notification-icon';
            if (unread) {
                dataSelectorId += '-unread';
            }
            if (isEmpty) {
                dataSelectorId += '-empty';
            }
            return (React.createElement(Wrapper, __assign({}, clearProps(rest), { ref: button.ref, role: "presentation", onClick: onClick, onMouseDown: function (e) {
                    button.onMouseDown(e);
                    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                }, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: function (e) {
                    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                }, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: "vm-AppBarNotification " + className, "data-selector-id": rest['data-selector-id'] || dataSelectorId, style: style }),
                React.createElement(Icon, { size: ICON_SIZES.xl, src: React.createElement(NotificationIcon, { unread: unread, empty: isEmpty }) })));
        },
        renderContent: function () {
            return (React.createElement(PopoverContent, { direction: STACK_DIRECTION.column },
                React.createElement(NotificationList, null, (messagesList === null || messagesList === void 0 ? void 0 : messagesList.length) ? (messagesList) : (React.createElement(Empty, { "data-selector-id": "notification-no-notifications", text: (texts === null || texts === void 0 ? void 0 : texts.empty) || 'No notifications' }))),
                (showClearAll || !noAutoDisplay) && (React.createElement(NotificationFooter, null,
                    React.createElement(StackView, { borderTop: VIEW_BORDER.normal, align: STACK_ALIGN.center, distribution: showClearAll
                            ? STACK_DISTRIBUTION.between
                            : STACK_DISTRIBUTION.end, spaceVertical: INDENT.s, spaceHorizontal: INDENT.m, gap: STACK_GAP.m },
                        showClearAll && (React.createElement(StackView, { gap: STACK_GAP.s, align: STACK_ALIGN.center, distribution: STACK_DISTRIBUTION.end },
                            React.createElement(Button, { "data-selector-id": "notification-clear-all", disabled: messagesList.length === 0, ui: BUTTON_VIEW.text, onClick: onClearAllClick },
                                React.createElement(Icon, { src: React.createElement(ClearAllIcon, null) }),
                                (texts === null || texts === void 0 ? void 0 : texts.clearAll) || 'Clear All'))),
                        !noAutoDisplay && (React.createElement(StackView, { testId: "auto-display-controller-container", gap: STACK_GAP.s, align: STACK_ALIGN.center, distribution: STACK_DISTRIBUTION.end },
                            React.createElement(Text, null, (texts === null || texts === void 0 ? void 0 : texts.autoDisplay) || 'Auto-display new messages'),
                            React.createElement(Toggle, { value: isAutoDisplay, onChange: onAutoDisplayChange }))))))));
        }
    })[0];
    return element;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=AppBarNotification.js.map